/* Lusso: smooth open/close for the filter groups (<details>) in the sidebar / top layouts.
   Uses event delegation so it keeps working after facets.js re-renders the filters. */
(function () {
  var DURATION = 320;
  var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';

  function panel(details) {
    return details.querySelector(':scope > .facets__display');
  }

  function open(details) {
    var p = panel(details);
    if (!p) { details.open = true; return; }
    details.open = true;
    details.classList.add('is-animating');
    var h = p.scrollHeight;
    p.style.overflow = 'hidden';
    var anim = p.animate(
      [{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }],
      { duration: DURATION, easing: EASE }
    );
    var done = function () {
      p.style.overflow = '';
      details.classList.remove('is-animating');
    };
    anim.onfinish = anim.oncancel = done;
    setTimeout(done, DURATION + 100);
  }

  function close(details) {
    var p = panel(details);
    if (!p) { details.open = false; return; }
    details.classList.add('is-animating');
    var h = p.scrollHeight;
    p.style.overflow = 'hidden';
    var anim = p.animate(
      [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
      { duration: DURATION, easing: EASE }
    );
    var done = function () {
      details.open = false;
      p.style.overflow = '';
      details.classList.remove('is-animating');
    };
    anim.onfinish = anim.oncancel = done;
    setTimeout(done, DURATION + 100);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('summary.facets__summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;
    var wrapper = details.closest('.collection-wrapper--filters-sidebar, .collection-wrapper--filters-top');
    if (!wrapper || !window.matchMedia('(min-width: 990px)').matches) return;
    if (e.target.closest('facet-remove, a, input, label')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    e.preventDefault();
    if (details.classList.contains('is-animating')) return;
    if (details.open) { close(details); return; }
    // accordion: only one group open at a time
    wrapper.querySelectorAll('details.facets__disclosure[open]').forEach(function (other) {
      if (other !== details && !other.classList.contains('is-animating')) close(other);
    });
    open(details);
  }, true);

  // "top" layout: click outside closes the open dropdown
  document.addEventListener('click', function (e) {
    var wrapper = document.querySelector('.collection-wrapper--filters-top');
    if (!wrapper || !window.matchMedia('(min-width: 990px)').matches) return;
    if (e.target.closest('details.facets__disclosure')) return;
    wrapper.querySelectorAll('details.facets__disclosure[open]').forEach(function (d) {
      if (!d.classList.contains('is-animating')) close(d);
    });
  });
})();
